export default {
  title: `
    Libérez votre potentiel de programmation <br /> avec les cours en direct de SkillSynergy !
  `,
  meeting: "Réservez une consultation gratuite",
};
